<template>
  <layout>
    <template slot="content">
      <i-card title="全局设置" content-width="800px">
        <template slot="content">
          <el-form label-width="160px" size="small">
            <el-form-item required :label="item.label" v-for="item in settings" :key="item.name">
              <el-input :placeholder="'请输入'+item.label" :type="item.ext_info.text_type" :rows="5"
                        v-model="item.value"
                        v-if="item.type === 1"></el-input>
              <i-upload v-model="item.ori_cover" :max-files="parseInt(item.ext_info.max_image)"
                        :size="item.ext_info.size"
                        v-if="item.type === 2"></i-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="sub" :loading="loading">提交</el-button>
              <el-button @click="$router.push({name: 'store.list'})">返回列表</el-button>
            </el-form-item>
          </el-form>
        </template>
      </i-card>
    </template>
  </layout>
</template>

<script>
  import iEditor from "@/components/i-editor.vue";
  import iUpload from "@/components/i-upload.vue";

  export default {
    name: "settings",
    components: {
      iEditor, iUpload
    },
    data() {
      return {
        loading: false,
        settings: []
      }
    },
    methods: {
      sub: function () {
        for (let i in this.settings) {
          if (this.settings[i].type === 2 && this.settings[i].ori_cover.length <= 0) {
            this.$message({type: "error", message: "请上传" + this.settings[i].label});
            return;
          }
          if (this.settings[i].type === 2) {
            let _self = this;
            _self.settings[i].value = "";
            this.settings[i].ori_cover.forEach(row => {
              _self.settings[i].value += row.path + '|';
            });
          }
        }
        this.$http.request('updateSettings', {settings: this.settings}).then(res => {
          if (res.status === 'success') {
            this.$message({type: 'success', message: res.message});
          }
        });
      },
      getSettings: function () {
        this.$http.request('allSettings').then(res => {
          if (res.status === 'success') {
            this.settings = res.data;
          }
        });
      },
    },
    created: function () {
      this.getSettings();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/settings.vue